import React, { useRef, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { Mensaje, MensajeSiNo } from "../mensajes";
import { Dimmer } from "../spinner";
import moment from "moment";
import axios from "axios";

export const SolicitudSolvencia = (props) => {
  const fechaSistema = JSON.parse(localStorage.getItem("fechasistema"));
  const idusuario = JSON.parse(localStorage.getItem("idusuario"));

  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [mensajesino, setMensajesino] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [activate, setActivate] = useState(false);
  const [agente, setAgente] = useState({
    idagente: "",
    nombre: "",
    rif: "",
    direccion: "",
  });

  const [visibleF, setVisibleF] = useState("hidden");
  const txtIdsolvencia = useRef();
  const txtIdagente = useRef();
  const txtNombre = useRef();
  const txtRif = useRef();
  const txtDireccion = useRef();
  const txtFechaSolicitud = useRef();
  const txtEstatusNotificacion = useRef();
  const txtMotivoRechazo = useRef();
  const btnCancela = useRef();
  const btnAcepta = useRef();

  const token = JSON.parse(localStorage.getItem("jwtToken"));
  let op = require("../../../public/modulos/datos");

  const onChange = (e) => {
    if (e.target.name === "estatusnotificacion") {
      if (e.target.value === "3") {
        setVisibleF("visible");
      } else {
        setVisibleF("hidden");
      }
    }
  };

  const onChangeValidar = (e) => {
    e.preventDefault();
    var sigue = true;

    if (txtIdagente.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Debe Introducir el codigo",
        icono: "informacion",
      });
      sigue = false;
      txtIdagente.current.focus();
    } else if (txtNombre.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Debe Introducir el nombre",
        icono: "informacion",
      });
      sigue = false;
      txtNombre.current.focus();
    } else if (txtRif.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Introduzca el RIF",
        icono: "informacion",
      });
      sigue = false;
      txtRif.current.focus();
    } else if (txtDireccion.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Introduzca la Direccion",
        icono: "informacion",
      });
      sigue = false;
      txtDireccion.current.focus();
    } else if (sigue) {
      let msg = "";
      if (props.operacion === 1) {
        msg = "Esta Seguro de Registrar estos Datos?.";
      } else if (props.operacion === 2) {
        msg = "Esta Seguro de Modificar estos Datos?.";
      } else if (props.operacion === 3) {
        msg = "Esta Seguro de Eliminar estos Datos?.";
      }

      setMensajesino({
        mostrar: true,
        titulo: "Confirmación.",
        texto: msg,
        icono: "confirmacion",
      });
    }
  };

  const seleccionarRegistro = (idage) => {
    let campos =
      "idagente, trim(nombre) as nombre, rif, trim(direccion) as direccion";
    let nomtab = "agente";
    let nomid = "idagente";

    let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&id=${idage}&nomtab=${nomtab}&nomid=${nomid}`;

    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data !== "") {
            setAgente(response.data);
          } else {
            setAgente({
              idagente: "",
              nombre: "",
              rif: "",
              direccion: "",
            });
          }
        }

        setActivate(false);
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const Actualizar = () => {
    setActivate(true);
    let endpoint = `${op.conexion}/api/solvencia/actualizar/${props.operacion}`;
    let body;
    let solv = [];

    if (props.operacion === 2) {
      if (txtEstatusNotificacion.current.value === "0") {
        solv.push({
          idsolvencia: txtIdsolvencia.current.value,
          idagente: agente.idagente,
          fechasolicitud: fechaSistema,
        });
      } else if (txtEstatusNotificacion.current.value === "1") {
        solv.push({
          idsolvencia: txtIdsolvencia.current.value,
          idagente: agente.idagente,
          fechasolicitud: txtFechaSolicitud.current.value,
          estatusnotificacion: txtEstatusNotificacion.current.value,
          aprobaciondia: fechaSistema,
          usuarioaprueba: idusuario,
        });
      } else if (txtEstatusNotificacion.current.value === "2") {
        solv.push({
          idsolvencia: txtIdsolvencia.current.value,
          idagente: agente.idagente,
          fechasolicitud: txtFechaSolicitud.current.value,
          estatusnotificacion: txtEstatusNotificacion.current.value,
          entregadia: fechaSistema,
          usuarioentrega: idusuario,
        });
      } else if (txtEstatusNotificacion.current.value === "3") {
        solv.push({
          idsolvencia: txtIdsolvencia.current.value,
          idagente: agente.idagente,
          fechasolicitud: txtFechaSolicitud.current.value,
          estatusnotificacion: txtEstatusNotificacion.current.value,
          rechazodia: fechaSistema,
          usuariorechaza: idusuario,
          motivorechazo: txtMotivoRechazo.current.value,
        });
      }
    } else {
      solv.push({
        idsolvencia: txtIdsolvencia.current.value,
        idagente: agente.idagente,
        fechasolicitud: fechaSistema,
      });
    }

    body = {
      solic: solv,
    };

    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (props.operacion === 1) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto: "registro creado correctamente",
              icono: "exito",
            });
          } else if (props.operacion === 2) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto: "registro modificado correctamente",
              icono: "exito",
            });
          } else if (props.operacion === 3) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto: "registro eliminado correctamente",
              icono: "exito",
            });
          }
        }
        setActivate(false);
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const blanquear = () => {
    setActivate(false);
    setVisibleF("hidden");
    setAgente({
      idagente: "",
      nombre: "",
      rif: "",
      direccion: "",
    });

    txtFechaSolicitud.current.value = moment(fechaSistema).format("YYYY-MM-DD");
    txtEstatusNotificacion.current.value = "0";
    txtMotivoRechazo.current.value = "";
  };

  const handleCloseSi = () => {
    Actualizar();
    setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
  };

  const cerrarModal = () => {
    props.onHide("1");
    blanquear();
    setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
  };

  const cancelar = () => {
    blanquear();
    props.onHide("0");
  };

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static"
      keyboard={false}
      onShow={() => {
        btnAcepta.current.focus();
        if (props.operacion !== 1) {
          seleccionarRegistro(props.solvencia.idagente);
          txtIdsolvencia.current.value = props.solvencia.idsolvencia;
          txtFechaSolicitud.current.value = moment(
            props.solvencia.fechasolicitud
          ).format("YYYY-MM-DD");
          txtEstatusNotificacion.current.value =
            props.solvencia.estatusnotificacion;
          if (props.solvencia.estatusnotificacion === 3) {
            setVisibleF("visible");
            txtMotivoRechazo.current.value = props.solvencia.motivorechazo;
          }
        }
      }}
    >
      <Modal.Header className="azulGradiant2">
        <Modal.Title style={{ color: "#fff" }}>Solicitud Solvencia</Modal.Title>
        <button
          ref={btnCancela}
          className="btn"
          style={{ border: 0, margin: 0, padding: 0, color: "#ffffff" }}
          onClick={cancelar}
        >
          <i className="far fa-window-close"></i>
        </button>
      </Modal.Header>
      <Modal.Body
        className="amanecergris"
        style={{ backgroundColor: "#FFF", color: "" }}
      >
        <Mensaje
          mensaje={mensaje}
          onHide={() => {
            mensaje.titulo === "Exito."
              ? cerrarModal()
              : setMensaje({
                  mostrar: false,
                  titulo: "",
                  texto: "",
                  icono: "",
                });
          }}
        />
        <MensajeSiNo
          mensaje={mensajesino}
          onHideNo={() =>
            setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" })
          }
          onHideSi={handleCloseSi}
        />
        <Dimmer active={activate} />
        <div style={{ height: "65vh", overflow: "auto" }}>
          <div style={{ fontFamily: "Times New Roman, Times, serif" }}>
            <div className="row rounded mx-auto">
              <div className="card bg-gradient-light">
                <div className="card-header">
                  <h5 className="card-title">Datos de la Solicitud</h5>
                </div>
                <div className="card-body">
                  <div className="rounded border border-info py-3">
                    <div className="col-md-12 row py-2">
                      <div className="input-group input-group-sm col-sm-3">
                        <label
                          className="input-group-text"
                          style={{ backgroundColor: "#55acee" }}
                          id="inputGroup-sizing-sm"
                        >
                          Codigo:
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          aria-label="Sizing example input"
                          aria-describedby="inputGroup-sizing-sm"
                          disabled
                          ref={txtIdagente}
                          value={agente.idagente}
                        />
                      </div>

                      <div className="input-group input-group-sm col-sm-5">
                        <label
                          className="input-group-text"
                          style={{ backgroundColor: "#55acee" }}
                          id="inputGroup-sizing-sm"
                        >
                          Nombre:
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          aria-label="Sizing example input"
                          aria-describedby="inputGroup-sizing-sm"
                          ref={txtNombre}
                          disabled
                          name="tipo"
                          value={agente.nombre}
                        />
                      </div>

                      <div className="input-group input-group-sm col-sm-4">
                        <label
                          className="input-group-text"
                          style={{ backgroundColor: "#55acee" }}
                          id="inputGroup-sizing-sm"
                        >
                          Rif:
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          aria-label="Sizing example input"
                          aria-describedby="inputGroup-sizing-sm"
                          disabled
                          value={agente.rif}
                          ref={txtRif}
                        />
                      </div>
                      <div className="my-1"></div>

                      <div className="input-group input-group-sm col-md-12">
                        <label
                          className="input-group-text"
                          style={{ backgroundColor: "#55acee" }}
                          id="inputGroup-sizing-sm"
                        >
                          Direccion:
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          aria-label="Sizing example input"
                          aria-describedby="inputGroup-sizing-sm"
                          disabled
                          ref={txtDireccion}
                          value={agente.direccion}
                        />
                      </div>
                    </div>
                    <hr className="col-sm-11 py-0 px-2 mx-auto container text-success2" />
                    <div className="row col-md-12">
                      <div className="input-group input-group-sm col-sm-3">
                        <label
                          className="input-group-text"
                          style={{ backgroundColor: "#55acee" }}
                          id="inputGroup-sizing-sm"
                        >
                          Codigo Solicitud:
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          aria-label="Sizing example input"
                          aria-describedby="inputGroup-sizing-sm"
                          disabled
                          ref={txtIdsolvencia}
                          defaultValue={"0"}
                        />
                      </div>

                      <div className="input-group input-group-sm col-sm-4">
                        <label
                          className="input-group-text"
                          style={{ backgroundColor: "#55acee" }}
                          id="inputGroup-sizing-sm"
                        >
                          Fecha Solicitud:
                        </label>
                        <input
                          type="date"
                          className="form-control"
                          aria-label="Sizing example input"
                          aria-describedby="inputGroup-sizing-sm"
                          disabled
                          ref={txtFechaSolicitud}
                          name="fechasolicitud"
                          defaultValue={moment(fechaSistema).format(
                            "YYYY-MM-DD"
                          )}
                        />
                      </div>

                      <div
                        className="input-group input-group-sm col-sm-5"
                        style={{
                          visibility:
                            props.operacion !== 1 ? "visible" : "collapse",
                        }}
                      >
                        <label
                          className="input-group-text"
                          style={{
                            backgroundColor: "#dc3545",
                            color: "#FFFFFF",
                          }}
                          id="inputGroup-sizing-sm"
                        >
                          Estatus Solicitud:
                        </label>
                        <select
                          ref={txtEstatusNotificacion}
                          disabled={
                            props.operacion === 4 || props.operacion === 3
                              ? true
                              : false
                          }
                          autoComplete="off"
                          onChange={onChange}
                          className="form-select text-center"
                          id="estatusnotificacion"
                          name="estatusnotificacion"
                          defaultValue={"0"}
                        >
                          <option value="0">POR APROBAR</option>
                          <option value="1">APROBADA</option>
                          <option value="2">ENTREGADA</option>
                          <option value="3">RECHAZADA</option>
                        </select>
                      </div>
                      <div className="my-1"></div>
                      <div
                        className="input-group input-group-sm col-sm-12"
                        style={{ visibility: visibleF }}
                      >
                        <label
                          className="input-group-text"
                          style={{ backgroundColor: "#55acee" }}
                          id="inputGroup-sizing-sm"
                        >
                          Motivo Rechazo:
                        </label>
                        <input
                          type="text"
                          autoComplete="off"
                          disabled={
                            props.operacion === 4 || props.operacion === 3
                              ? true
                              : false
                          }
                          className="form-control"
                          aria-label="Sizing example input"
                          aria-describedby="inputGroup-sizing-sm"
                          defaultValue={""}
                          name="motivorechazo"
                          ref={txtMotivoRechazo}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button
          ref={btnAcepta}
          style={{ visibility: props.operacion !== 4 ? "visible" : "hidden" }}
          onClick={onChangeValidar}
          className="btn btn-sm rounded-pill btn-success col-md-2"
        >
          <i className="fas fa-check-circle"> Aceptar</i>
        </button>
        <button
          ref={btnCancela}
          onClick={cancelar}
          className="btn btn-danger btn-sm rounded-pill col-md-2"
        >
          <i className="fas fa-window-close"> Cancelar</i>
        </button>
      </Modal.Footer>
    </Modal>
  );
};



// WEBPACK FOOTER //
// ./src/components/solvencia/agregar_solvencia.js